import { render, staticRenderFns } from "./VisitorManuelBanModal.vue?vue&type=template&id=1a926a9c"
import script from "./VisitorManuelBanModal.vue?vue&type=script&lang=js"
export * from "./VisitorManuelBanModal.vue?vue&type=script&lang=js"
import style0 from "./VisitorManuelBanModal.vue?vue&type=style&index=0&id=1a926a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports